/**
 * @param  {array} arr     result from cntsInOneSubcatForPie.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[{
  name: "Country",
  //colorByPoint: true,
  data: [{
    name: "Canada",
    y: 56.33
  }, {
    name: "Mexico",
    y: 24.03
  }, 
  ...
  ]
}]
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cntsInOneSubcatForPieEachYear = cntsInOneSubcatForPieEachYear;
exports.cntsInOneSubcatForPieEachYearJustY = cntsInOneSubcatForPieEachYearJustY;

function cntsInOneSubcatForPieEachYear(arr, index) {
  var output = [];
  output.push({
    name: arr[0].name,
    //colorByPoint: arr[0].colorByPoint,
    data: []
  });

  arr[0].data.forEach(function (d, i) {
    output[0].data[i] = {
      name: d.name,
      y: d.y[index]
    };
  });
  //console.dir(output)
  return output;
}

/**
 * cntsInOneCatForPieEachYearJustY 
 * @param  {array} arr     result from cntsInOneSubcatForPie.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[12, 23, 21,...]
 */

function cntsInOneSubcatForPieEachYearJustY(arr, index) {
  var output = [];
  arr[0].data.forEach(function (d) {
    output.push(d.y[index]);
  });
  return output;
}
//# sourceMappingURL=data:application/json;base64,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